import { render, staticRenderFns } from "./TheFormStaff.vue?vue&type=template&id=743c6787&scoped=true&"
import script from "./TheFormStaff.vue?vue&type=script&lang=ts&"
export * from "./TheFormStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743c6787",
  null
  
)

export default component.exports